import { render } from "./AtendimentosWhatsAppTemplateForm.vue?vue&type=template&id=ee561b7e"
import script from "./AtendimentosWhatsAppTemplateForm.vue?vue&type=script&lang=js"
export * from "./AtendimentosWhatsAppTemplateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__